/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/device/history-icon.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3359f20d"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-info-detail device-info-page"
};
var _hoisted_2 = {
  class: "device-info-top"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "history-left"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "history-icon"
  }), /*#__PURE__*/_createElementVNode("div", {
    class: "left-content"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "left-title"
  }, "任务历史"), /*#__PURE__*/_createElementVNode("div", null, "/查看历史巡保记录")])], -1);
});
var _hoisted_4 = {
  key: 1,
  class: "device-info-collapse-list"
};
import DetailCollapselist from './DetailCollapselist.vue';
import { getDeviceType, getDeviceDetail, getDevicePatrolScheme, getDevicePatrolGuard } from '@/service/deviceInfo/index';
import './index.less';
import './common.less';
import './detail.less';
import { showToast } from 'vant';
var __default__ = {
  name: 'DeviceInfoDetail'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _route$query = route.query,
      factoryId = _route$query.factoryId,
      device_num = _route$query.device_num;
    var deviceColumns = ref([]);
    var listloading = ref(false);
    var finished = ref(false);
    var detailInfo = ref('');
    var patrolSchemeList = ref([]);
    var patrolGuardList = ref([]);
    var pageLoading = ref(true);
    var id = null; // 设备ID
    var onLoad = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onLoad() {
        return _ref.apply(this, arguments);
      };
    }();
    var onClickRight = function onClickRight() {
      if (id) {
        router.push({
          path: '/taskHistory',
          query: {
            id: id
          }
        });
      } else {
        showToast('获取详情失败请重新获取');
      }
    };
    var getDetail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
        var _data$eaDevice, res, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getDeviceDetail({
                factoryId: factoryId,
                deviceNum: device_num
              });
            case 3:
              res = _context2.sent;
              data = res.data;
              deviceColumns.value.forEach(function (item) {
                if (data.eaDevice.deviceTypeCode === item.dictValue) {
                  data.dictLabel = item.dictLabel;
                }
              });
              detailInfo.value = data;
              id = data === null || data === void 0 || (_data$eaDevice = data.eaDevice) === null || _data$eaDevice === void 0 ? void 0 : _data$eaDevice.id;
              return _context2.abrupt("return", Promise.resolve());
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", Promise.reject());
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 11]]);
      }));
      return function getDetail(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var getDeviceTypeList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data, list;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getDeviceType('device_type');
            case 2:
              res = _context3.sent;
              data = res.data;
              list = data.list;
              deviceColumns.value = list;
              // console.log(list, 'list', columns, 'col');
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function getDeviceTypeList() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _patrolSchemeRes$data, _patrolGuardRes$data, patrolSchemeRes, patrolGuardRes, schemeList, guardList;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            getDeviceTypeList();
            _context4.prev = 1;
            listloading.value = true;
            _context4.next = 5;
            return getDetail();
          case 5:
            _context4.next = 7;
            return getDevicePatrolScheme({
              t: id,
              pageIndex: 1,
              pageSize: 9999999
            });
          case 7:
            patrolSchemeRes = _context4.sent;
            _context4.next = 10;
            return getDevicePatrolGuard({
              t: id,
              pageIndex: 1,
              pageSize: 9999999
            });
          case 10:
            patrolGuardRes = _context4.sent;
            schemeList = (patrolSchemeRes === null || patrolSchemeRes === void 0 || (_patrolSchemeRes$data = patrolSchemeRes.data) === null || _patrolSchemeRes$data === void 0 ? void 0 : _patrolSchemeRes$data.records) || [];
            guardList = (patrolGuardRes === null || patrolGuardRes === void 0 || (_patrolGuardRes$data = patrolGuardRes.data) === null || _patrolGuardRes$data === void 0 ? void 0 : _patrolGuardRes$data.records) || [];
            patrolSchemeList.value = schemeList;
            patrolGuardList.value = guardList;
            listloading.value = false;
            finished.value = true;
            pageLoading.value = false;
            _context4.next = 26;
            break;
          case 20:
            _context4.prev = 20;
            _context4.t0 = _context4["catch"](1);
            listloading.value = false;
            finished.value = true;
            pageLoading.value = false;
            showToast('请求失败');
          case 26:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 20]]);
    })));
    return function (_ctx, _cache) {
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_loading = _resolveComponent("van-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        onClick: onClickRight,
        class: "device-history"
      }, [_hoisted_3, _createVNode(_component_van_icon, {
        name: "arrow",
        class: "arrow"
      })])]), !_unref(pageLoading) ? (_openBlock(), _createBlock(_component_van_list, {
        key: 0,
        loading: _unref(listloading),
        "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(listloading) ? listloading.value = $event : null;
        }),
        finished: _unref(finished),
        onLoad: onLoad
      }, {
        default: _withCtx(function () {
          return [_createVNode(DetailCollapselist, {
            listData: _unref(detailInfo),
            patrolSchemeList: _unref(patrolSchemeList),
            patrolGuardList: _unref(patrolGuardList)
          }, null, 8, ["listData", "patrolSchemeList", "patrolGuardList"])];
        }),
        _: 1
      }, 8, ["loading", "finished"])) : _createCommentVNode("", true), _unref(pageLoading) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_loading, {
        type: "spinner",
        vertical: ""
      }, {
        default: _withCtx(function () {
          return [_createTextVNode("加载中")];
        }),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
}));